import ContentBlock from '../ContentBlock';
import ImageLink from '../ImageLink';

const propTypes = {
	...ContentBlock.PropTypes,
	...ImageLink.PropTypes,
};

export default propTypes;
